var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { getIn } from "formik";
import { TextField } from "@mui/material";
export const FormTextField = (props) => {
    const isTouched = getIn(props.form.touched, props.field.name);
    const errorMessage = getIn(props.form.errors, props.field.name);
    const { error, helperText, field, form } = props, rest = __rest(props, ["error", "helperText", "field", "form"]);
    return (React.createElement(TextField, Object.assign({ variant: "outlined", inputProps: { "data-testid": `test_${props.field.name}` }, error: error !== null && error !== void 0 ? error : Boolean(isTouched && errorMessage), helperText: helperText !== null && helperText !== void 0 ? helperText : (isTouched && errorMessage ? errorMessage : undefined) }, rest, field)));
};
